import React, { useRef } from 'react';
import { ConnectedProps, connect } from 'react-redux';
import { Dispatch } from 'redux';
import SealLogCoverPage from './SealLogCoverPage';
import { useOnScrollToTop } from 'hooks/useScrollToTop';
import { inspectorSelectors } from 'redux/app/vessel/inspector';
import { IStore } from 'redux/store';
import { ESealState } from 'redux/app/logs/@types';
import { commonUtils } from 'redux/_common';

type OwnProps = {
	vesselId: string;
    showCoverPages?: boolean;
};
type SealLogsViewProps = PropsFromRedux & OwnProps;

function SealLogsView(props: SealLogsViewProps) {
    const { sealLogs, showCoverPages = false, vesselId } = props;
    const topDivRef = useRef<HTMLDivElement | null>(null);
    useOnScrollToTop(topDivRef);

    return (
        <div>
            <div className="h-0" ref={topDivRef} />
            {showCoverPages ? <SealLogCoverPage vesselId={vesselId} /> : null}
            <div className="px-8 py-4 newpage">
                <div className="p-4">
                    <div className="w-full bg-gray-100">
                        <table className="w-full wayship-table-light orb1-table">
                            <thead>
                                <tr className="theader">
                                    <th>
                                        <div className="p-2 m-px text-xs font-medium leading-4 tracking-wide text-left text-gray-600  border-gray-300 whitespace-nowrap min-w-[100px]">
                                            Location
                                        </div>
                                    </th>
                                    <th>
                                        <div className="p-2 m-px text-xs font-medium leading-4 tracking-wide text-center text-gray-600 border-gray-300 whitespace-nowrap min-w-20">
                                            Seal Fitted
                                        </div>
                                    </th>
                                    <th>
                                        <div className="p-2 m-px text-xs font-medium leading-4 tracking-wide text-center text-gray-600 border-gray-300 whitespace-nowrap min-w-20">
                                            Seal No.
                                        </div>
                                    </th>
                                    <th>
                                        <div className="p-2 m-px text-xs font-medium leading-4 tracking-wide text-left text-gray-600 border-gray-300 whitespace-nowrap min-w-20">
                                            Seal Removed
                                        </div>
                                    </th>
                                    <th>
                                        <div className="p-2 m-px text-xs font-medium leading-4 tracking-wide text-left text-gray-600 border-gray-300 whitespace-nowrap min-w-20">
                                            Reason for removal
                                        </div>
                                    </th>
                                    <th>
                                        <div className="p-2 m-px text-xs font-medium leading-4 tracking-wide text-left text-gray-600 border-gray-300 whitespace-nowrap min-w-20">
                                            Recorded By
                                        </div>
                                    </th>
                                    <th>
                                        <div className="p-2 m-px text-xs font-medium leading-4 tracking-wide text-left text-gray-600 border-gray-300 whitespace-nowrap min-w-20">
                                            C/E Initials
                                        </div>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {sealLogs.map((sealLog, index) => {
                                    const {
                                        sealNumber,
                                        location,
                                        history,
                                        createdProfile,
                                        approvedProfile,
                                        reason,
                                        state
                                    } = sealLog;

                                    const removed = history?.find(
                                        (seal) =>
                                            seal.state === ESealState.REMOVED
                                    );
                                    const fitted = history?.find(
                                        (seal) =>
                                            seal.state ===
                                            ESealState.CURRENTLY_IN_USE
                                    );

                                    return (
                                        <React.Fragment key={sealLog.id}>
                                            <tr>
                                                <td className="md:text-xs xl:text-sm">
                                                    {location}
                                                </td>
                                                <td className="md:text-xs xl:text-sm">
                                                    {fitted?.dateModified
                                                        ? commonUtils.formatSystemDate(
                                                              fitted?.dateModified,
                                                              true
                                                          )
                                                        : ''}
                                                </td>
                                                <td className="md:text-xs xl:text-sm">
                                                    {sealNumber}
                                                </td>
                                                <td>
                                                    {removed?.createdAt
                                                        ? commonUtils.formatSystemDate(
                                                              removed?.dateModified,
                                                              true
                                                          )
                                                        : ''}
                                                </td>
                                                <td className="md:text-xs xl:text-sm">
                                                    {state === ESealState.LOST ? `LOST: ${reason}` : removed?.reason}
                                                </td>
                                                <td>{createdProfile}</td>
                                                <td>{approvedProfile}</td>
                                            </tr>
                                        </React.Fragment>
                                    );
                                })}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    );
}

function mapStateToProps(store: IStore, ownProps: OwnProps) {
    const inspectorStore = inspectorSelectors?._getStore(store);
    const sealLogs = inspectorSelectors?.getSealLogs(inspectorStore);

    return {
        sealLogs
    };
}

function mapDispatchToProps(dispatch: Dispatch, ownProps: OwnProps) {
    return {};
}
const reduxConnector = connect(mapStateToProps, mapDispatchToProps);
type PropsFromRedux = ConnectedProps<typeof reduxConnector>;
export default reduxConnector(SealLogsView);
